import { useEffect, useState } from 'react'
import { UserCog, KeyRound } from 'lucide-react'
import { useAuth } from '../../store/auth'
import { saveProfile } from '../../lib/api/users'
import { PageHead, SectionCard, SaveBar, Field, TextInput, SelectInput, PasswordInput } from '../config/ui'

const LANGS = [
  { value: 'it', label: 'Italiano' },
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
]

export function AccountPage() {
  const user = useAuth((s) => s.user)

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [language, setLanguage] = useState('it')
  const [pwd, setPwd] = useState('')
  const [pwd2, setPwd2] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [ok, setOk] = useState(false)

  useEffect(() => {
    if (user) {
      setName(user.name ?? '')
      setEmail(user.email ?? '')
      setLanguage(user.language ?? 'it')
    }
  }, [user])

  const dirty =
    Boolean(user) &&
    (name !== (user?.name ?? '') ||
      email !== (user?.email ?? '') ||
      language !== (user?.language ?? 'it') ||
      pwd.length > 0)

  async function onSave() {
    setError(null)
    setOk(false)
    if (pwd && pwd !== pwd2) {
      setError('Le due password non coincidono.')
      return
    }
    setSaving(true)
    try {
      await saveProfile({ name, email, language, ...(pwd ? { password: pwd } : {}) })
      setPwd('')
      setPwd2('')
      setOk(true)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Errore durante il salvataggio')
    } finally {
      setSaving(false)
    }
  }

  function onReset() {
    if (user) {
      setName(user.name ?? '')
      setEmail(user.email ?? '')
      setLanguage(user.language ?? 'it')
    }
    setPwd('')
    setPwd2('')
    setError(null)
    setOk(false)
  }

  return (
    <div className="w-full px-6 pb-16 pt-7 lg:px-9">
      <PageHead title="Il mio profilo" description="Aggiorna i tuoi dati operatore e la password di accesso al gestionale." />
      <div className="max-w-2xl space-y-[18px]">
        <SectionCard title="Dati operatore" icon={UserCog}>
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Username" hint="Non modificabile">
              <TextInput value={user?.username ?? ''} onChange={() => {}} disabled mono />
            </Field>
            <Field label="Nome">
              <TextInput value={name} onChange={setName} placeholder="Nome operatore" />
            </Field>
            <Field label="Email">
              <TextInput value={email} onChange={setEmail} placeholder="nome@garagesanmarco.it" />
            </Field>
            <Field label="Lingua">
              <SelectInput value={language} onChange={setLanguage} options={LANGS} />
            </Field>
          </div>
        </SectionCard>

        <SectionCard title="Cambia password" icon={KeyRound} desc="Lascia i campi vuoti per non modificare la password.">
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Nuova password">
              <PasswordInput value={pwd} onChange={setPwd} placeholder="••••••••" />
            </Field>
            <Field label="Conferma password">
              <PasswordInput value={pwd2} onChange={setPwd2} placeholder="••••••••" />
            </Field>
          </div>
        </SectionCard>

        <SaveBar dirty={dirty} saving={saving} error={error} ok={ok} onSave={onSave} onReset={onReset} />
      </div>
    </div>
  )
}
